module.exports = __webpack_public_path__ + "static/media/S_E03.2af2cd73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_E03.png
// module id = 131
// module chunks = 0